import type { BillHistory } from "../api/reportsBillsHistory";

// „Закриване на сметка(1)" — умишлено нефискализираната сметка В БРОЙ (трите
// клика, право `close_bill_1`). Огледало на `cash_no_receipt_clause()` в
// BE (`app/features/bills/models.py`): closed + total = 0 + метод 1 + без
// депозит.
//
// `total` се пълни САМО от успешен фискален бон, тоест нулата значи „няма
// касова бележка"; методът отделя трите клика от останалите закрити сметки с
// `total = 0` — „Плащане по сметка", метод „БЕЗ ФИСКАЛИЗИРАНЕ", карта/смесено
// с паднала фискализация. Те са легитимни пари и си остават фактурируеми.
// Платената (изцяло или отчасти) с депозит не е трите клика никога (BE
// отказва депозит с pm 1 + `total = 0`): бонът ѝ приспада депозита (Бон 2),
// а без бон е паднала фискализация — легитимни пари, фактурират се.
export const CASH_NO_RECEIPT_PAYMENT_METHOD_ID = 1;

/** Закрита в брой без бон — такава сметка НЕ подлежи на фактуриране. */
export const isCashNoReceiptBill = (
  bill: Pick<BillHistory, "status" | "total" | "payment_method_id" | "deposit_amount">,
): boolean =>
  bill.status === "closed" &&
  Number(bill.total ?? 0) === 0 &&
  bill.payment_method_id === CASH_NO_RECEIPT_PAYMENT_METHOD_ID &&
  Number(bill.deposit_amount ?? 0) === 0;
